/** Hook for getting the list of next actions for all projects. */
import { useMemo } from 'react';
import { useTasksContext } from '@/features/tasks/context/TasksContext.def';
import { useNextAction } from '@/features/tasks/hooks/status/use-task-next-action';
import { getNextActionsList } from '@/features/tasks/utils/views/nextActionUtils';

export const useNextActions = () => {
  const { tasksMap, filteredTasks } = useTasksContext();
  const nextActionMap = useNextAction();

  const filteredTaskIds = useMemo(
    () => new Set(filteredTasks.map((t) => t.id)),
    [filteredTasks],
  );

  return useMemo(
    () => getNextActionsList(tasksMap, nextActionMap, filteredTaskIds),
    [tasksMap, nextActionMap, filteredTaskIds],
  );
};
